import React from "react"
import styled from "styled-components"
import { colors } from "../../common/colors/app_colors"
import TagSelect from "../tag_select"
import { getItemsArray } from "../../util/prop_utils"
import { DeleteIcon } from "../onboarding/invite_member_row"

const { silver } = colors

export class KeywordTagMatchingItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            keyword: "",
            tags: [],
            tagId: "",
        }
    }

    componentDidMount() {
        const { tags, keyword, tagId, tag } = this.props
        const foundTag = tagId ? [tags.items[tagId]] : tag ? [tag] : []
        this.setState({ tags: foundTag, keyword, tagId })
    }

    componentDidUpdate(prevProps) {
        const { id, tagId, keyword, tags, tag } = this.props
        if (
            prevProps.id != id ||
            prevProps.tagId != tagId ||
            prevProps.keyword != keyword
        ) {
            const foundTag = tagId ? [tags.items[tagId]] : tag ? [tag] : []
            this.setState({ tags: foundTag, keyword, tagId })
        }
    }

    handleKeywordChange = ({ target }) => {
        const { tags } = this.state
        const keyword = target.value
        this.setState({ keyword })
        if (tags.length !== 0) {
            const { guid, sendTagKeyword } = this.props
            const tag = tags[0]
            sendTagKeyword(guid, keyword, tag)
        }
    }

    handleSelectChange = tag => {
        const { guid, sendTagKeyword } = this.props
        sendTagKeyword(guid, this.state.keyword, tag)
    }

    stateSetter = field => {
        return value => {
            const currentTag = value[value.length - 1]
            if (currentTag) {
                this.handleSelectChange(currentTag)
                return this.setState({ [field]: [currentTag] })
            }
            this.handleSelectChange(null)
            return this.setState({ [field]: [] })
        }
    }

    render() {
        const {
            guid,
            tags,
            teams,
            viewerPersonalTeamId,
            team,
            removeTagMatch,
        } = this.props
        const teamId = team.id
        const tagsArray = getItemsArray(tags)
        const isPersonal = team.isPersonal
        const tagsToShow = isPersonal
            ? tagsArray
            : tagsArray.filter(tag => tag.teamId === teamId)
        return (
            <KeyTagMatchingItemWrapper>
                <input
                    onChange={this.handleKeywordChange}
                    type="text"
                    placeholder="Keyword"
                    value={this.state.keyword}
                    className="form-control text-field"
                />
                <div className="tag-select">
                    <TagSelect
                        tags={tagsToShow}
                        values={this.state.tags}
                        tagMap={tags.items}
                        onValuesChange={this.stateSetter("tags")}
                        placeholder="Tag"
                        teams={teams.items}
                        viewerPersonalTeamId={viewerPersonalTeamId}
                        autofocus={false}
                        className="tag-input"
                    />
                </div>
                <DeleteIcon id={guid} action={removeTagMatch} />
            </KeyTagMatchingItemWrapper>
        )
    }
}

const KeyTagMatchingItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 0px;
    margin-bottom: 10px;
    align-items: center;
    justify-content: space-between;
    .inline-icon-x {
        margin: 0;
        padding: 0px;
        height: 16px;
        width: 16px;
        cursor: pointer;
    }
    .text-field {
        width: 45%;
        overflow: hidden;
        resize: none;
        border-radius: 4px;
        border: 1px solid ${silver};
        outline: none;
    }
    .text-field:focus {
        border: 1px solid ${silver};
    }
    .tag-select {
        width: 45%;
    }
    .option-wrapper {
        padding: 0.6em;
    }
    @media (max-width: 600px) {
        display: flex;
        flex-direction: column;
        .text-field {
            width: 100%;
            margin-bottom: 10px;
        }
        .tag-select {
            width: 100%;
        }

        .inline-icon-x {
            align-self: flex-end;
            margin-top: 5px;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/key_word_tag_matching_item.jsx